import { List, Map } from 'immutable'
import i18next from 'i18next'
import wopi360Service from '../services/wopi360'

const RESET = 'wopi360-questionnaire/RESET'
const FETCH = 'wopi360-questionnaire/FETCH'
const START = 'wopi360-questionnaire/START'
const ANSWER = 'wopi360-questionnaire/ANSWER'
const PRE_ANSWER = 'wopi360-questionnaire/PRE_ANSWER'
const FETCH_TRANSLATIONS = 'wopi360-questionnaire/FETCH_TRANSLATIONS'
const ERROR = 'wopi360-questionnaire/ERROR'

const ANSWER_OPEN = 'wopi360-questionnaire/ANSWER_OPEN'

const SELECT_ROLE = 'wopi360-questionnaire/SELET_ROLE'
const SELECT_ROLE_SUCCESS = 'wopi360-questionnaire/SELECT_ROLE_SUCCESS'

const defaultState = Map({
  isLoading: true,
  uuid: null,
  questions: List(),
  openQuestions: List(),
  role: null,
  activeQuestionIndex: 0,
  target: null,
  language: null,
  isStarted: null,
  activeQuestionAnswer: null,
  isTranslationReady: false,
  error: null
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case RESET:
      return defaultState

    case FETCH:
      if (!action.payload) {
        return state.update('language', language => 'en').update('isLoading', isLoading => false)
      }

      return state
        .update('uuid', uuid => action.payload.uuid)
        .update('activeQuestionIndex', index => action.payload.activeQuestionIndex)
        .update('questions', questions => List(action.payload.answers))
        .update('openQuestions', openQuestions => List(action.payload.openAnswers))
        .update('role', role => action.payload.role)
        .update('target', target => action.payload.target)
        .update('isTarget', isTarget => action.payload.isTarget)
        .update('language', language => action.payload.defaultLanguage)
        .update('isStarted', startedAt => !!action.payload.startedAt)
        .update('isLoading', isLoading => false)
        .update('isFinished', isFinished => !!action.payload.finishedAt)

    case FETCH_TRANSLATIONS:
      return state
        .update('isTranslationReady', isReady => action.payload.isReady)
        .update('language', language => action.payload.language)

    case PRE_ANSWER:
      return state.update('activeQuestionAnswer', activeAnswer => action.payload)

    case ANSWER:
      return state
        .update('questions', questions => action.payload.questions)
        .update('activeQuestionAnswer', isAnswered => null)
        .update('activeQuestionIndex', index => action.payload.activeQuestionIndex)

    case START:
      return state.update('isStarted', isStarted => true)

    case SELECT_ROLE_SUCCESS:
      return state.update('role', role => action.payload.role)

    case ANSWER_OPEN:
      return state.update('openQuestions', openQuestions => action.payload.openQuestions)

    case ERROR:
      return state.update('error', error => action.payload)

    default:
      return state
  }
}

export function resetWopi360Questionnaire() {
  return dispatch => {
    dispatch({ type: RESET })
  }
}

export function fetchWopi360Questionnaire(uuid) {
  return dispatch => {
    return wopi360Service
      .getWopi360(uuid)
      .then(response => dispatch({ type: FETCH, payload: response.data }))
      .catch(() => dispatch({ type: FETCH })) // TODO: wat?
  }
}

export function fetchTranslationsForWopi360Questions(language) {
  return dispatch => {
    wopi360Service
      .getTranslationsForWopi360Questions(language)
      .then(response => {
        Object.keys(response.data).forEach(namespace => {
          i18next.addResourceBundle(language, namespace, response.data[namespace])
        })

        return dispatch({
          type: FETCH_TRANSLATIONS,
          payload: {
            isReady: true,
            language
          }
        })
      })
      .catch(() => {}) // TODO: ???
  }
}

export function answerWopi360Questions(uuid, questions, activeQuestionIndex, answers) {
  const questionsWithNewAnswers = questions.map(categoryAnswers => {
    categoryAnswers.answers = categoryAnswers.answers.map(answer => {
      if (answers.has(answer.id)) {
        return {
          id: answer.id,
          answer: answers.get(answer.id)
        }
      }

      return answer
    })

    return categoryAnswers
  })

  const flattenedQuestionsWithNewAnswers = questionsWithNewAnswers.reduce(
    (acc, categoryAnswers) => {
      return categoryAnswers.answers.reduce((a, answer) => {
        return a.push(answer)
      }, acc)
    },
    List()
  )

  let nextActiveQuestionIndex = flattenedQuestionsWithNewAnswers.findIndex(answer => !answer.answer)

  if (nextActiveQuestionIndex === -1) {
    nextActiveQuestionIndex = flattenedQuestionsWithNewAnswers.size
  }

  return dispatch => {
    const payload = {
      activeQuestionIndex: nextActiveQuestionIndex,
      questions: questionsWithNewAnswers
    }

    return wopi360Service
      .answerWopi360Questions(uuid, flattenedQuestionsWithNewAnswers, nextActiveQuestionIndex)
      .then(() => dispatch({ type: ANSWER, payload }))
      .catch(e => dispatch({ type: ERROR, payload: e }))
  }
}

export function answerWopi360OpenQuestions(uuid, openAnswers) {
  return dispatch => {
    const openQuestions = openAnswers
      .map((answer, id) => {
        return {
          id,
          answer
        }
      })
      .toList()

    return wopi360Service
      .answerWopi360OpenQuestions(uuid, openQuestions)
      .then(() => dispatch({ type: ANSWER_OPEN, payload: { openQuestions } }))
      .catch(e => dispatch({ type: ERROR, payload: e }))
  }
}

export function startWopi360Questionnaire(uuid) {
  return dispatch => {
    wopi360Service.startWopi360(uuid).then(() => dispatch({ type: START }))
  }
}

export function selectWopi360QuestionnaireRole(uuid, role) {
  return dispatch => {
    dispatch({ type: SELECT_ROLE })

    wopi360Service
      .selectWopi360Role(uuid, role)
      .then(response => dispatch({ type: SELECT_ROLE_SUCCESS, payload: response.data }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/wopi360-questionnaire.js